import { Tab, Tabs } from "@blueprintjs/core"
import { useState, useEffect } from "react"

import { useLocation, useNavigate } from "react-router-dom"
import { capitalizeFirstLetter } from "../../../utils"
import { ConfigContainer } from "./Config.styled"
import ApiKeys from "./ApiKeys/ApiKeys"
import Company from "./Company/Company"
import Dataset from "./Dataset/Dataset"
import Instrument from "./Instrument/Instrument"
import { ConfigDisplayTab } from "./types"

const Config = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [selectedTab, setSelectedTab] = useState<ConfigDisplayTab>(ConfigDisplayTab.COMPANY)

  useEffect(() => {
    const pathSegments = location.pathname.split("/")
    // Find the index of 'config' and get the next segment as the tab
    const configIndex = pathSegments.findIndex(segment => segment === "config")
    const tabFromPath =
      configIndex >= 0 ? (pathSegments[configIndex + 1] as ConfigDisplayTab) : null
    if (tabFromPath) {
      setSelectedTab(tabFromPath)
    }
  }, [location.pathname])

  return (
    <ConfigContainer flexDirection="column" selectedTab={selectedTab}>
      <Tabs
        id="config-tabs"
        onChange={id => {
          setSelectedTab(id as ConfigDisplayTab)
          navigate(`/config/${id}`)
        }}
        selectedTabId={selectedTab}
        /**
         * renderActiveTabPanelOnly avoids warning:
         *      " AG Grid tried to call sizeColumnsToFit() but the grid is coming back
         *      with zero width, maybe the grid is not visible yet on the screen? "
         */
        renderActiveTabPanelOnly
        large
        animate={false} // prevents the indicator of the selected tab from being misplaced
      >
        <Tab
          id={ConfigDisplayTab.COMPANY}
          title={capitalizeFirstLetter(ConfigDisplayTab.COMPANY)}
          panel={<Company />}
        />
        <Tab
          id={ConfigDisplayTab.INSTRUMENT}
          title={capitalizeFirstLetter(ConfigDisplayTab.INSTRUMENT)}
          panel={<Instrument />}
        />
        <Tab
          id={ConfigDisplayTab.DATASET}
          title={capitalizeFirstLetter(ConfigDisplayTab.DATASET)}
          panel={<Dataset />}
        />
        <Tab id={ConfigDisplayTab.API_KEYS} title="MCP tokens" panel={<ApiKeys />} />
      </Tabs>
    </ConfigContainer>
  )
}

export default Config
